module.exports = __webpack_public_path__ + "static/media/landing-page-hero-image.8dc49577.png";